module.exports = {
    gitVersion: 'c412854e3ef1aa261a1177d6aa41edc0d25fa766',
    appVersion: '25.5.2',
};
